<template lang="es">
<div class="profile">
    <Navigation></Navigation>

	<Loader :show="loading" type="inline"></Loader>
	
    <div class="container add_top_30 add_bottom_30" v-if="!loading">
        <div class="row">
			
            <div class="col col-lg-3">
                
                <ProfileSidebar></ProfileSidebar>

            </div>

			<div class="col-md-12 col-lg-9" >
                <div class="container box_general">
                    <div class="header_box">
                        <h2><i class="pe-7s-id"></i>Mi perfil</h2>
                    </div>
                    <div class="row">
                        <div class="col">

                            <div class="mt-4 mb-2">
                                <div class="header_box"> 
                                    <router-link tag="a" class="btn btn-xs btn-link pull-right mt-1" to="/profile/personal-data">Modificar</router-link>
                                    <h3>Datos personales</h3>
                                </div>
                                <table class="table table-borderless table-right-titles table-sm table-first-30">
                                    <tr>
                                        <td>Nombre y apellido</td>
                                        <td>{{me.name}} {{me.lastname}}</td>
                                    </tr>
                                    <tr>
                                        <td>Documento</td>
                                        <td>
                                            <span v-if="me.doc_type=='CI'">CI:</span>
                                            <span v-if="me.doc_type=='Passport'">Documento:</span>
                                            {{me.doc_number}}</td>
                                    </tr>
                                    <tr>
                                        <td>Género</td>
                                        <td>
                                            <span v-if="me.gender=='male'">Masculino</span>
                                            <span v-if="me.gender=='female'">Femenino</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Fecha de nacimiento</td>
                                        <td>
                                            <span v-if="me.birthdate">{{me.birthdate | moment("DD-MM-YYYY") }} </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Teléfono</td>
                                        <td>{{me.phone}}</td>
                                    </tr>
                                    <tr v-if="me.address_country">
                                        <td>País</td>
                                        <td>
                                            {{me.address_country.name}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Dirección</td>
                                        <td>
                                            <span v-if="me.address_street">{{me.address_street}} {{me.address_number}} <br></span>
                                            <span v-if="me.address_comments">{{me.address_comments}} <br></span>
                                            <small v-if="me.address_locality">{{me.address_locality.name}}, {{me.address_locality.region.name}} <br></small>
                                        </td>
                                    </tr>
                                </table>
                                
                            </div>

                            <div class="mt-4 mb-2">
                                <div class="header_box"> 
                                    <router-link tag="a" class="btn btn-xs btn-link pull-right mt-1" to="/password-change">Cambiar contraseña</router-link>
                                    <h3>Datos de acceso</h3>
                                </div>
                                <table class="table table-borderless table-right-titles table-sm table-first-30">
                                    <tr>
                                        <td>Email</td>
                                        <td>{{me.email}}</td>
                                    </tr>
                                    <tr>
                                        <td>Contraseña</td>
                                        <td>**********</td>
                                    </tr>
                                </table>                                    
                            </div>


                            <div class="mt-4 mb-2">
                                <div class="header_box"> 
                                    <router-link tag="a" class="btn btn-xs btn-link pull-right mt-1" to="/profile/medical">Modificar</router-link>
                                    <h3>Perfil médico</h3>
                                </div>
                                <table class="table table-borderless table-right-titles table-sm table-first-30">
                                    <tr>
                                        <td>Emergencia médica</td>
                                        <td>
                                            <span v-for="emergency in me.emergencies" ::key="emergency.name">
                                                {{emergency.name}} 
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Mutualista</td>
                                        <td>
                                            <span v-for="mutualist in me.mutualists" ::key="mutualist.name">
                                                {{mutualist.name}} 
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Seguro médico</td>
                                        <td>
                                            <span v-for="prepaid_medicine in me.prepaid_medicines" ::key="prepaid_medicine.name">
                                                {{prepaid_medicine.name}} 
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Afecciones</td>
                                        <td>
                                            <span v-for="affection in me.affections" ::key="affection.name">
                                                {{affection.name}} 
                                            </span>
                                        </td>
                                    </tr>
                                    
                                </table>                                    
                            </div>

                        </div>    
                    </div>    
                </div>


            </div>


        </div>
        
    </div>

    <Footer></Footer>

</div>
</template>

<script>
import gql from 'graphql-tag'
import { mapGetters } from 'vuex'

import Loader from '@/components/Loader';
import Navigation from '@/components/Navigation';
// import ProfilePicture from '@/components/ProfilePicture';
import ProfileSidebar from '@/components/ProfileSidebar';

export default {
    name: 'Profile',
    metaInfo: {
		title: 'Perfil',
	},
    components: {
        Navigation,
        ProfileSidebar,
        Loader
    },
    computed: {
		...mapGetters(['isAuthenticated','loggedUser'])
	},
    data() {
        return {
            me:{},
            validationErrors:{},
            loading:true,
        }
    },
    apollo: {
        me: {
            query: gql`query{
                me {
                    id
                    name
                    lastname
                    doc_type
                    doc_number
                    phone
                    email
                    birthdate
                    gender
                    picture{
                        id
                        filename
                        urlThumb
                    }
                    address_locality_id
                    address_street
                    address_number
                    address_comments
                    address_country{
                        name
                    }
                    address_locality{
                        name
                        region{
                            id
                            name
                        }
                    }
                    mutualists{
                        name
                    }
                    emergencies{
                        name
                    }
                    prepaid_medicines{
                        name
                    }
                    affections{
                        name
                    }
                }
            }`,
            fetchPolicy: 'no-cache',
            result (data) {
                console.log(data)
                this.me = data.data.me;
                // if(this.form.address_locality){
                //     this.form.address_region_id = this.form.address_locality.region.id;	
                //     this.loadLocalities(this.form.address_region_id);
                // }
                this.loading=false;
            },
        }
    },
    
}
</script>

<style scoped>

</style>
